import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import { getFileUploadTypes } from '../../../utils/utilities';
import { IMAGE_LIMITS } from '../../../utils/constants';

import toastService from '../../../services/toastService';

class CustomAutGeneralDrawingForm extends Form {
	state = {
		data: { generalDrawing: [] },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
		generalDrawing: Joi.array().min(1).max(IMAGE_LIMITS.ISO_IMAGE).required().label('General Drawing'),
	};

	static propTypes = {
		initialGeneralDrawing: PropTypes.array,
	}

	componentDidMount() {
		if (this.props.initialGeneralDrawing) {
			this.setState({ data: { generalDrawing: this.props.initialGeneralDrawing }});
		}
	}

	doSubmit = () => {
		this.props.onSave(this.state.data.generalDrawing);
		toastService.success('General Drawing saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderFileInput({
					max: IMAGE_LIMITS.ISO_IMAGE,
					multiple: IMAGE_LIMITS.ISO_IMAGE > 1,
					name: 'generalDrawing',
					accept: 'image/*,application/pdf',
					label: 'General Drawing',
					sublabel: 'Upload General Drawing',
					types: getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Save General Drawing')}
				</div>
			</form>
		);
	}
}

export default CustomAutGeneralDrawingForm;
